import { getElementChild, getElementChildren, getElements } from '../Utility/Dom'
import { IS_ACTIVE } from '../Utility/State'

class Tabs {
  private items: NodeListOf<HTMLElement>

  init(): void {
    this.items = getElements('tabs')

    this.addEvents()
  }

  private addEvents(): void {
    this.items.forEach((item: HTMLElement): void => {
      const tabButtons = getElementChildren(item, 'tab-button')
      const tabPanes = getElementChildren(item, 'tab-pane')
      const tabNavigation = getElementChild(item, 'tab-nav')

      if (!tabButtons.length || !tabPanes.length) return

      const activeButton= this.getActiveTabButton(tabButtons)
      if (activeButton) {
        setTimeout(() => this.updateIndicator(activeButton, tabNavigation), 0)
      }

      tabButtons.forEach((button: HTMLElement): void => {
        button.addEventListener('click', (): void => {
          const paneId = button.getAttribute('aria-controls')

          if (!paneId) return

          tabButtons.forEach((button: HTMLElement): void => {
            button.setAttribute('aria-selected', 'false')
          })

          tabPanes.forEach((pane: HTMLElement): void => {
            pane.classList.remove(IS_ACTIVE)
          })

          button.setAttribute('aria-selected', 'true')
          this.updateIndicator(button, tabNavigation)

          const activePane = document.querySelector('#' + paneId)
          if (activePane !== null) {
            activePane.classList.add(IS_ACTIVE)
          }
        })
      })

      window.addEventListener('resize', (): void => {
        const activeButton= this.getActiveTabButton(tabButtons)

        if (activeButton) {
          this.updateIndicator(activeButton, tabNavigation)
        }
      })
    })
  }

  private getActiveTabButton(buttons: [] | NodeListOf<HTMLElement>): HTMLElement {
    return Array.from(buttons).find((button: HTMLElement): boolean =>
      button.getAttribute('aria-selected') === 'true'
    )
  }

  private updateIndicator(button: HTMLElement, navigation: HTMLElement): void {
    const buttonRect = button.getBoundingClientRect()
    const navRect = navigation.getBoundingClientRect()

    navigation.style.setProperty('--indicator-width', `${buttonRect.width}px`)
    navigation.style.setProperty('--indicator-offset', `${buttonRect.left - navRect.left + navigation.scrollLeft}px`)
  }
}

const tabs = new Tabs()
tabs.init()
